import React from 'react'
import { useTranslation } from 'react-i18next'

interface PageLoadingProps {
  message?: string
  text?: string
  fullscreen?: boolean
  size?: 'sm' | 'md' | 'lg'
}

export const PageLoading: React.FC<PageLoadingProps> = ({ message, text, fullscreen = true }) => {
  const { t } = useTranslation()
  const loadingMessage = message || text || t('common.loading.default')

  return (
    <div
      className={`flex flex-col items-center justify-center ${fullscreen ? 'min-h-screen' : 'py-20'}`}
    >
      <div className="relative">
        <div className="w-16 h-16 rounded-full animate-spin border-4 border-gray-200 border-t-primary" />
      </div>
      <p className="mt-4 text-gray-600">{loadingMessage}</p>
    </div>
  )
}
